import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class TerraceGardens2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.TERRACE_GARDENS2;
}

export default TerraceGardens2PoiTileEntity;
